import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { Icon } from "./icon";
import { environment } from "../environments/environment";

@Component({
  selector: "app-footer",
  imports: [RouterLink, Icon],
  template: `
    <footer class="grain surface-ink pt-24 pb-10 relative overflow-hidden">
      <div
        class="mesh-blob mesh-blob-a w-[500px] h-[500px] -top-64 -right-32 bg-saffron/10"
      ></div>
      <div
        class="mesh-blob mesh-blob-b w-[350px] h-[350px] bottom-0 -left-32 bg-teal/15"
      ></div>
      <div class="container relative z-10">
        <div
          class="grid grid-cols-1 lg:grid-cols-12 gap-16 pb-20 border-b border-paper/10"
        >
          <div class="lg:col-span-4 space-y-8">
            <img
              src="/logo.png"
              alt="Step Into Sri Lanka"
              class="h-12 w-auto brightness-0 invert"
              referrerpolicy="no-referrer"
            />
            <p class="text-paper/60 text-[15px] leading-relaxed max-w-sm">
              A small Colombo-based studio of guides and planners who route
              journeys across the island - Cultural Triangle to Hill Country to
              the southern coast - one itinerary at a time.
            </p>
            <div class="flex items-center gap-3">
              <a
                href="#"
                aria-label="Facebook"
                class="w-10 h-10 rounded-full border border-paper/15 flex items-center justify-center text-paper/60 hover:text-saffron hover:border-saffron/60 hover:-translate-y-0.5 transition-all"
              >
                <app-icon name="facebook" [size]="16" />
              </a>
              <a
                href="#"
                aria-label="Instagram"
                class="w-10 h-10 rounded-full border border-paper/15 flex items-center justify-center text-paper/60 hover:text-saffron hover:border-saffron/60 hover:-translate-y-0.5 transition-all"
              >
                <app-icon name="instagram" [size]="16" />
              </a>
              <a
                href="#"
                aria-label="YouTube"
                class="w-10 h-10 rounded-full border border-paper/15 flex items-center justify-center text-paper/60 hover:text-saffron hover:border-saffron/60 hover:-translate-y-0.5 transition-all"
              >
                <app-icon name="play" [size]="16" />
              </a>
            </div>
          </div>

          <div class="lg:col-span-2 lg:col-start-6">
            <h4
              class="text-[10px] uppercase tracking-[0.3em] font-bold text-saffron mb-8"
            >
              Explore
            </h4>
            <ul class="space-y-4">
              <li>
                <a
                  routerLink="/"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Home</a
                >
              </li>
              <li>
                <a
                  routerLink="/tours"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Tours</a
                >
              </li>
              <li>
                <a
                  routerLink="/attractions"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Attractions</a
                >
              </li>
              <li>
                <a
                  routerLink="/ayurveda"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Wellness</a
                >
              </li>
              <li>
                <a
                  routerLink="/gallery"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Gallery</a
                >
              </li>
              <li>
                <a
                  routerLink="/about"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Our Story</a
                >
              </li>
              <li>
                <a
                  routerLink="/contact"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Contact</a
                >
              </li>
            </ul>
          </div>

          <div class="lg:col-span-2">
            <h4
              class="text-[10px] uppercase tracking-[0.3em] font-bold text-saffron mb-8"
            >
              Signature Routes
            </h4>
            <ul class="space-y-4">
              <li>
                <a
                  [routerLink]="['/tours', 'panoramic-tours-sri-lanka']"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Panoramic Tours</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/tours', 'kandy-cultural-heritage']"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Kandy Heritage</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/tours', 'sigiriya-ancient-rock']"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Sigiriya</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/tours', 'beach-holiday-getaway']"
                  class="text-paper/60 hover:text-paper text-sm transition-colors"
                  >Beach Holiday</a
                >
              </li>
            </ul>
          </div>

          <div class="lg:col-span-3">
            <h4
              class="text-[10px] uppercase tracking-[0.3em] font-bold text-saffron mb-8"
            >
              Reach Us
            </h4>
            <div class="space-y-5">
              <a
                [href]="'mailto:' + contactEmail"
                class="flex items-start gap-3 group"
              >
                <app-icon
                  name="mail"
                  [size]="16"
                  class="text-saffron mt-0.5 shrink-0"
                />
                <span
                  class="text-paper/70 group-hover:text-paper text-sm transition-colors break-all"
                  >{{ contactEmail }}</span
                >
              </a>
              <a [href]="'tel:' + contactPhoneHref" class="flex items-start gap-3 group">
                <app-icon
                  name="phone"
                  [size]="16"
                  class="text-saffron mt-0.5 shrink-0"
                />
                <span
                  class="text-paper/70 group-hover:text-paper text-sm transition-colors"
                  >{{ contactPhone }}</span
                >
              </a>
              <div class="flex items-start gap-3">
                <app-icon
                  name="pin"
                  [size]="16"
                  class="text-saffron mt-0.5 shrink-0"
                />
                <span class="text-paper/70 text-sm">Colombo 03, Sri Lanka</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="flex flex-col md:flex-row items-center justify-between pt-10 gap-6"
        >
          <p class="text-paper/35 text-[11px] tracking-wide">
            &copy; 2026 Step Into Sri Lanka. All journeys, carefully routed.
            @if (!isProduction) {
              <span class="text-saffron/60">(dev build)</span>
            }
          </p>
          <div class="flex items-center gap-8">
            <a
              href="#"
              class="text-paper/35 hover:text-paper text-[11px] uppercase tracking-[0.15em] font-bold transition-colors"
              >Privacy</a
            >
            <a
              href="#"
              class="text-paper/35 hover:text-paper text-[11px] uppercase tracking-[0.15em] font-bold transition-colors"
              >Terms</a
            >
          </div>
        </div>

        <details class="mt-6 group">
          <summary
            class="text-paper/30 text-[11px] tracking-wide cursor-pointer hover:text-paper/50 transition-colors list-none"
          >
            Photo credits
          </summary>
          <p class="text-paper/30 text-[11px] leading-relaxed mt-3 max-w-3xl">
            Select tour photography via
            <a
              href="https://commons.wikimedia.org"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Wikimedia Commons</a
            >:
            <a
              href="https://commons.wikimedia.org/wiki/File:Elephant_Bathing_at_Pinnawala_Elephant_Orphanage,_2015-04-04-2.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Alexey Komarov (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Sri_Lanka_-_Anuradhapura_-_Ruwanweliseya.JPG"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >BluesyPete (CC BY-SA 3.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Gal_Vihara_Polonnaruwa.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Philip Nalangan (CC BY 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Mirissa,_whale_watching,_blue_whale_(6918166357).jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Arian Zwegers (CC BY 2.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Hikkaduwa_Beach.JPG"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Shehanw (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:SL_Ella_asv2020-01_img01_Ravana_Falls.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >A.Savin (Free Art License)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Srilankan_leopard_in_Yala_National_Park.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >AdrianRanasinghe (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Horton_Plains_-_World's_end.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >JeninRathnayake (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:SL_Kandy_asv2020-01_img33_Sacred_Tooth_Temple.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >A.Savin (Free Art License)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Gangaramaya_Temple.JPG"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >AKS.9955 (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Koneswaram_Temple_in_2023.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Alexey Komarov (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Elephant_Gathering_in_Minneriya.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Mahoora Tented Safari Camps (CC BY-SA 4.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:SL_Negombo_asv2020-01_img04_Fish_Market_building.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >A.Savin (Free Art License)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Ayurveda_-_Turmeric,_Boswellia,_Ashwagandha_and_Fenugreek_-_50191955812.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Formulate Health (CC BY 2.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Negombo_Beach,_Sri_Lanka.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >S B from Sydney (CC BY 2.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Cinnamomum_verum_spices.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Simon A. Eugster (CC BY-SA 3.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Lotus_flower_(978659).jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Hong Zhang (CC0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Sri_Lanka,_Bentota,_beach_(1).JPG"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Vincent van Zeijst (CC BY-SA 3.0)</a
            >,
            <a
              href="https://commons.wikimedia.org/wiki/File:Madu_Ganga,_Sri_Lanka.jpg"
              target="_blank"
              rel="noopener noreferrer"
              class="underline hover:text-paper/50"
              >Brian de Mel (CC BY-SA 4.0)</a
            >.
          </p>
        </details>
      </div>
    </footer>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class Footer {
  contactEmail = environment.contactEmail;
  contactPhone = environment.contactPhone;
  contactPhoneHref = environment.contactPhoneHref;
  isProduction = environment.production;
}
